import { mapState } from 'vuex';
import { themesMixin } from '../../../../utils/themes';
export default {
  name: 'CoreDtwinRuleExecutionHistoryExport',
  mixins: [themesMixin],
  props: {
    ruleId: {
      type: Number,
      required: true
    }
  },
  data: function () {
    const start = new Date(new Date() - 86400000 * 2);
    const end = new Date();
    return {
      start,
      end,
      exportQuery: {
        ruleId: this.ruleId,
        time: {
          from: start,
          to: end
        }
      },
      formValid: true
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    backgroundColor() {
      return `background-color: ${this.vuetifyColorHex('info')}`;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    borderColor() {
      return this.UiTheme ? 'rgba(255, 255, 255, 0.25)' : 'transparent';
    }
  },
  methods: {
    datePicked(dateObject) {
      this.start = new Date(dateObject.from * 1000);
      this.end = new Date(dateObject.to * 1000);
      this.exportQuery = {
        ...this.exportQuery,
        time: {
          from: this.start,
          to: this.end
        }
      };
    }
  }
};